export enum CatExpertRouterLink {
  Login = "login",

  Home = "home",

  Studio = "studio",

  Create = "create",

  Assortment = "assortment",

  SpaceAssortment = "space-assortment",

  ClusteringInsights = "clustering-insights",

  Clustering = "clustering",

  DataExploration = "data-exploration",

  Pho = "pho",

  Edit = "edit",

  Eda = "eda",

  Experiments = "experiments",

  Nesting = "nesting",

  LevelZero = "level-zero",

  Simulation = "simulation",

  Optimization = "optimization",

  Settings = "settings",

  SkuFunnel = "sku-funnel",

  ClusterPlanoOverview = "cluster-plano-overview",

  DynamicNesting = "dynamic-nesting",

  Voting = "voting",

  Vote = "vote",

  LogisticsFramework = "logistics-framework",

  ProjectDetails = "project-details",

  GeneratePublish = "generate-publish",

  PlanogramDashboard = "plano-dashboard",

  Planogram = "planogram",

  // planogram v3 routes
  PlanogramV3 = "v3",
  Grid = "grid",
  Segment = "space",
  Product = "product",

  Dashboard = "global-dashboard",

  // Space Plano Create Flow Routes

  Cluster = "cluster",

  CreatePlan = "create-plano",

  UploadMappingFile = "upload-mapping-file",

  ConfigDynamicNesting = "configure-dynamic-nesting",

  AssortmentSummary = "assortment-summary",

  SpacePlanogram = "space-planogram",

  ClassicPlanogram = "classic-planogram",

  CustomizePDFDashboard = "pdf-template-dashboard",

  Bulk = "bulk",

  CreateBulkImport = "create-bulk-import",

  BulkEdit = "edit",

  BulkEditResult = "result",
}
